import React from 'react';
import './App.css';
import TreatmentPlanSuggestion from './components/TreatmentPlanSuggestion';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <TreatmentPlanSuggestion />
      </header>
    </div>
  );
}

export default App;